import script from "./WeekResults.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekResults.vue?vue&type=script&setup=true&lang=js"

import "./WeekResults.vue?vue&type=style&index=0&id=5fe9f208&lang=scss"

const __exports__ = script;

export default __exports__